import { render, staticRenderFns } from "./calendar_edit.vue?vue&type=template&id=4b5fa644&scoped=true"
import script from "./calendar_edit.vue?vue&type=script&lang=js"
export * from "./calendar_edit.vue?vue&type=script&lang=js"
import style0 from "./calendar_edit.vue?vue&type=style&index=0&id=4b5fa644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fa644",
  null
  
)

export default component.exports